import React, { useState, useEffect } from "react";
import { CardMedia, Grid, CardActionArea, Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import ArticleControls from './ArticleControls.js'
import { editArticleMetadata, createArticle } from '../utils.js'
import DeleteArticleDialog from "./DeleteArticleDialog.js";
import Tags from "../Tags.js";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

export default function ArticleCard(props = {}) {
  const navigate = useNavigate()
  const location = useLocation()
  const {
    index,
    article,
    maxWidth = '100%',
    minHeight = undefined,
    editable,
    published,
    sx = {},
    visibility
  } = props

  const [hovering, setHovering] = useState(false)
  const [deleteArticleDialogOpen, setDeleteArticleDialogOpen] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();

  const handleAddQuery = (newQuery) => {
    setHovering()
    const currentParams = new URLSearchParams(searchParams.toString());
    currentParams.set(newQuery.key, newQuery.value);
    navigate(`${location.pathname}?${currentParams.toString()}`);
  };

  const viewArticle = () => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      navigate(article.guid)
    }
  }

  const shareArticle = async (payload) => {
    console.log('article, payload', article, payload)
  }

  return (<>
    <DeleteArticleDialog
      open={deleteArticleDialogOpen}
      article={article}
      onClose={() => setDeleteArticleDialogOpen(false)}
    />

    <Card
      sx={{
        display: 'flex',
        ...sx
      }}
      key={'article' + index}
      className="secondary-article-card"
      style={{
        maxWidth,
        minHeight
      }}>
      <CardActionArea
        component='div'
        sx={{ display: 'flex' }}
        onMouseOver={() => setHovering(true)}
        onMouseOut={() => setHovering()}
        onClick={() => viewArticle()}
      >
        <Box 
        className="image-overlay"
         />
        {/* <Box className=".gradient-overlay" /> */}
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image" />
        <CardMedia component="div" sx={article.image ? { backgroundImage: `url(${article.image})` } : undefined} alt="Featured Article" className="featured-image-blurred" />

        <CardContent className="secondary-article-content" >
          <Typography variant="body1" className="secondary-article-titleg">
            {article.title}
          </Typography>
          <Typography variant="body2">
            {article.author} - {article.date}
          </Typography>
          <Tags
            tags={article?.tags || ""}
            onSelectTag={_ => setHovering()}
            clickable={published}
            sx={{ marginTop: '4px' }}
          />
        </CardContent>
        {editable && <ArticleControls
          isDraft={article?.isDraft}
          isPinned={article?.metadata?.isPinned}
          hovering={hovering}
          onClickEdit={() => editArticleMetadata(article, visibility)}
          onClickDelete={() => setDeleteArticleDialogOpen(true)}
          showAdd={false}
          article={article}
        />}
      </CardActionArea>

    </Card>
  </>)
}